import React from 'react';
// FIGMA: https://www.figma.com/file/isI24MS5FurNhkXfDybGSc/Fibe---Web-Handover?node-id=12066-204497&t=M9CY9w5lkU54PMjR-0
import inviteFriend from '../../../assets/nach-cancellation/inviteFriend.svg';
import getQuiker from '../../../assets/nach-cancellation/getQuiker.svg';
import safeSecure from '../../../assets/nach-cancellation/safeSecure.svg';
import eligibleLimit from '../../../assets/nach-cancellation/eligibleLimit.svg';
const InformativeCard = () => {
  const informativeCardsDataArr = [
    {
      imageSrc: inviteFriend,
      primaryText: 'Invite your friends',
      secondaryText:
        'No need to visit our app for repayments if your Auto Debit is active',
    },
    {
      imageSrc: getQuiker,
      primaryText: 'Eligible for higher limits',
      secondaryText:
        'Improve your chances of getting higher cash limits by keeping Auto Debit active',
    },
    {
      imageSrc: safeSecure,
      primaryText: 'Safe, Reliable & Secure',
      secondaryText:
        'Avoid technical errors & failed transactions by keeping your Auto Debit active',
    },
    {
      imageSrc: eligibleLimit,
      primaryText: 'Get next loan quicker',
      secondaryText:
        'If you disable your Auto Debit, next loan disbursement can get delayed',
    },
  ];
  return (
    <>
      {/* InformativeCard */}
      <div className="grid gap-7 grid-cols-1 grid-rows-1 lg:grid-cols-2 lg:grid-rows-2 p-4 lg:p-0">
        {informativeCardsDataArr.map((singleCardData, idx) => {
          return (
            <div className="" key={idx}>
              <div className="">
                <img src={singleCardData.imageSrc} alt="inviteFriend" />
              </div>
              <div className="text-text-primary text-lg my-4">
                {singleCardData.primaryText}
              </div>
              <div className="text-text-secondary text-base w-full lg:w-3/5">
                {singleCardData.secondaryText}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default InformativeCard;
